import * as React from "react";
import { TableCell } from "../table/table-cell/table-cell.mjs";
import { Term } from "./term.mjs";
import { cellBEM } from "./utils.mjs";
const DataCell = (props) => {
  const { data, isMobile = false, categoryItem, width = 2 } = props;
  if (isMobile && categoryItem) {
    return /* @__PURE__ */ React.createElement(TableCell, { className: cellBEM(categoryItem.isDifferent), valign: "top", width }, /* @__PURE__ */ React.createElement(
      Term,
      {
        label: /* @__PURE__ */ React.createElement(React.Fragment, null, categoryItem.label, categoryItem.labelAside && /* @__PURE__ */ React.createElement(React.Fragment, null, " ", categoryItem.labelAside))
      },
      data && /* @__PURE__ */ React.createElement(DataCellContent, { data, isMobile })
    ));
  }
  return /* @__PURE__ */ React.createElement(TableCell, { className: cellBEM(data == null ? void 0 : data.isDifferent), width }, data && /* @__PURE__ */ React.createElement(DataCellContent, { data }));
};
const DataCellContent = (props) => {
  const { data, isMobile = false } = props;
  return /* @__PURE__ */ React.createElement("div", { className: detailItemBEM(data, isMobile) }, data.value || "-", " ", data.priceUnit && data.priceUnit);
};
const detailItemBEM = (item, isMobile = false) => {
  const classArray = [];
  if ((item.normalPrice || item.priceUnit) && !isMobile || item.priceUnit && !item.normalPrice) {
    classArray.push("text-bold");
  }
  if (item.normalPrice) {
    classArray.push("text-light");
  }
  if (item.isMissing || typeof item.value === "undefined") {
    classArray.push("text-light");
  }
  return classArray.join(" ");
};
export {
  DataCell
};
